import { Component, OnInit } from '@angular/core';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { take } from 'rxjs/operators';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import Chart from 'chart.js';

@Component({
  selector: 'grafica-corredores',
  templateUrl: './grafica-corredores.component.html',
  styleUrls: ['./grafica-corredores.component.scss']
})
export class GraficaCorredoresComponent implements OnInit {
  public plugin = ChartDataLabels;
  public options: any;
  public data: any;
  public corredores: ElementoCatalogo[] = [];
  public colors: string[] = [
    "#FF6384",
    "#36A2EB",
    "#FFCE56",
    "#CCFF00",
    "#CCFFCC",
    "#CC6600",
    "#CC66FF",
    "#FF6600",
    "#CC3333",
    "#CC0000",
    "#6633FF",
    "#666600",
    "#669900",
    "#66FF00",
    "#339966",
    "#003300"
  ];

  constructor(
    private catalogoService: CatalogoService
  ) { } 

  async ngOnInit() {
    Chart.plugins.unregister(ChartDataLabels);
    this.corredores = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CORREDORES).pipe(take(1)).toPromise();
    this.cargarConfigGrafica();
    this.data = {
      labels: this.corredores.map((c: ElementoCatalogo) => c.nombre),
      datasets: [
        {
          label: "Cantidad",
          data: this.corredores.map((c: ElementoCatalogo) => parseInt(c.key) + 1),
          backgroundColor: '#bb9767',
          borderColor: '#bb9767'
        }
      ]
    };
  }


  public cargarConfigGrafica() {
    this.options = {
      // plugins: {
      //   datalabels: {
      //     align: 'top',
      //     anchor: 'end',
      //     borderRadius: 4,
      //     // backgroundColor: 'black',
      //     color: 'black',
      //     font: {
      //       weight: 'bold'
      //     }
      //   }
      // },
      // scales: {
      //   yAxes: [{
      //     ticks: {
      //       // Include a dollar sign in the ticks
      //       callback: function (value, index, values) {
      //         return '$' + value;
      //       }
      //     },
      //     scaleLabel: {
      //       display: true,
      //       labelString: 'Millones de pesos'
      //     }
      //   }]
      // },
      layout: {
        padding: {
          top: 10
        }
      },
      legend: {
        position: 'bottom'
      },

      // tooltips: {
      //   intersect: true,
      //   callbacks: {
      //     label: function (tooltipItem, data) {
      //       let label = data.datasets[tooltipItem.datasetIndex].label || '';
      //       return label + " $" + tooltipItem.yLabel + " Clic para ver detalle";
      //     }
      //   }
      // },
      elements: {
        line: {
          tension: 0
        }
      }
    };
  }


}
